// extracted by css-extract-rspack-plugin
export default {"fake-button":"fhEKcP","fakeButton":"fhEKcP"};